import React, { useMemo, useState } from 'react';
import './index.scss';

function SchedulePickerModal({ lecture, onConfirm }) {
  const { listen_type, ClassOfflineSchedules, ClassConsultingSchedules, ClassOnlineScheduleByRounds } = lecture;

  const rawSchedules = useMemo(() => {
    const studentCount = (s) => (s.student_count || 0) + (s.student_ready_count || 0);
    if (listen_type === 'offline') {
      return (ClassOfflineSchedules || []).map((s) => ({
        id: s.id,
        class_round: s.class_round,
        createdAt: s.createdAt,
        label: `${s.class_round}기 | ${s.title || '옵션명 없음'} | ${s.start_date}~${s.end_date}`,
        count: studentCount(s),
      }));
    }
    if (listen_type === 'consulting') {
      return (ClassConsultingSchedules || []).map((s) => ({
        id: s.id,
        class_round: s.class_round,
        createdAt: s.createdAt,
        label: `${s.class_round}기 | ${s.title || '옵션명 없음'} | ${s.start_date}~${s.end_date}`,
        count: studentCount(s),
      }));
    }
    if (listen_type === 'roundOnline') {
      return (ClassOnlineScheduleByRounds || []).map((s) => ({
        id: s.id,
        class_round: s.class_round,
        createdAt: s.createdAt,
        label: `${s.class_round ? `${s.class_round}기` : '기수 없음'} | ${s.title || '옵션명 없음'} | ${
          s.start_date || '시작일 없음'
        }~${s.end_date || '종료일 없음'}`,
        count: studentCount(s),
      }));
    }
    return [];
  }, [listen_type, ClassOfflineSchedules, ClassConsultingSchedules, ClassOnlineScheduleByRounds]);

  const [sortDir, setSortDir] = useState('desc');

  // 1단계: 기수, 2단계(기수 동률 시 타이브레이크): 개설 시점
  const schedules = useMemo(() => {
    const sorted = [...rawSchedules];
    sorted.sort((a, b) => {
      const av = a.class_round ?? 0;
      const bv = b.class_round ?? 0;
      if (av < bv) return sortDir === 'asc' ? -1 : 1;
      if (av > bv) return sortDir === 'asc' ? 1 : -1;
      const aSecondary = a.createdAt ?? 0;
      const bSecondary = b.createdAt ?? 0;
      if (aSecondary < bSecondary) return sortDir === 'asc' ? -1 : 1;
      if (aSecondary > bSecondary) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [rawSchedules, sortDir]);

  const [selectedIds, setSelectedIds] = useState(new Set(schedules.map((s) => s.id)));

  const toggleId = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <div className="schedule-picker-modal">
      <p className="schedule-picker-modal__desc">다운로드할 기수를 선택하세요.</p>
      <div className="schedule-picker-modal__bulk-actions">
        <button
          className="schedule-picker-modal__bulk-btn"
          onClick={() => setSelectedIds(new Set(schedules.map((s) => s.id)))}
        >
          전체 선택
        </button>
        <button className="schedule-picker-modal__bulk-btn" onClick={() => setSelectedIds(new Set())}>
          전체 해제
        </button>
        <div className="schedule-picker-modal__sort-bar">
          <button
            type="button"
            className="schedule-picker-modal__sort-dir-btn"
            onClick={() => setSortDir((prev) => (prev === 'desc' ? 'asc' : 'desc'))}
          >
            {sortDir === 'desc' ? '내림차순 ▼' : '오름차순 ▲'}
          </button>
        </div>
      </div>
      <ul className="schedule-picker-modal__list">
        {schedules.map((schedule) => (
          <li key={schedule.id} className="schedule-picker-modal__item">
            <label>
              <input type="checkbox" checked={selectedIds.has(schedule.id)} onChange={() => toggleId(schedule.id)} />
              <span className="schedule-picker-modal__item-label">{schedule.label}</span>
              <span className="schedule-picker-modal__item-count">{schedule.count}명</span>
            </label>
          </li>
        ))}
      </ul>
      <button
        className="schedule-picker-modal__confirm-btn"
        onClick={() => onConfirm(selectedIds)}
        disabled={selectedIds.size === 0}
      >
        다운로드
      </button>
    </div>
  );
}

export default SchedulePickerModal;
